import React from 'react';
import { formatDate } from '../utils/dateutils';

const ShowMore = (props) => {
  const { slotDate, count, localizer, onShowMoreClickListener } = props;

  // Handles the click event to show more (drilldown view navigation)
  // e: The click event object triggered by the button click
  const onShowMoreClick = (e) => {
    const { drilldownView } = props;
    document.querySelector(`[data-key=${drilldownView}]`).click();
    onShowMoreClickListener(slotDate);
  }

  return (
    <button 
      type="button" 
      className="rbc-button-link rbc-show-more" 
      onClick={onShowMoreClick} 
      data-slot-date={formatDate(slotDate)}
    >
      + {count} {localizer.messages.showMore}
    </button>
  );
};

export default ShowMore;
